export default "__VITE_ASSET__p36UgIpg__"